"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.GLOBALS = new core_1.InjectionToken('Global config for sortablejs');
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-sortablejs/dist/src/globals.js
// module id = ./node_modules/angular-sortablejs/dist/src/globals.js
// module chunks = vendor